export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const SET_ONBOARD_DATA = "SET_ONBOARD_DATA";
export const SET_LOGOUT_USER = "SET_LOGOUT_USER";
